import { useDeleteMerchantNotification } from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/hooks/useDeleteMerchantNotification';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { DeleteDialog } from 'shared/mui/Dialogs';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { MerchantNotification } from 'types/embedded/merchantNotification';

type MerchantsShowNotificationsDeleteDialogProps = {
  onClose: VoidFunction;
  open: boolean;
  record: MerchantNotification;
  onCloseSuccess: VoidFunction;
};

export const MerchantsShowNotificationsDeleteDialog: React.FC<
  MerchantsShowNotificationsDeleteDialogProps
> = ({ onClose, open, record, onCloseSuccess }) => {
  const translate = useTypedTranslate();

  const { deleteMerchantNotification, isLoading } = useDeleteMerchantNotification(record.id, () => {
    onCloseSuccess();
    queryClient.invalidateQueries({ queryKey: ['merchant_notification_settings'] });
  });

  return (
    <DeleteDialog
      details={
        <Typography>
          {translate('app.merchantsShowNotifications.notificationSettingsDeletionMessage1')}{' '}
          <TypographyBold fontSize={16} text={`ID ${record.id}`} />{' '}
          {translate('app.merchantsShowNotifications.notificationSettingsDeletionMessage2')}
        </Typography>
      }
      isLoading={isLoading}
      onClose={onClose}
      onDelete={deleteMerchantNotification}
      onSuccess={onCloseSuccess}
      open={open}
      title={translate('app.merchantsShowNotifications.notificationSettingsDeletionTitle')}
    />
  );
};
